import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";
import styles from "../../styles/Calender.module.css"
const Calender = () => {
  
  return (
    <div className={styles.Git} >
    <h1 className={styles.heading}>Git Calender</h1>
    <div  >   
      <h1 className={styles.heading2}>
        Days I Code
      </h1>
      <GitHubCalendar
        username="charchit07"
        blockSize={15}
        blockMargin={5}
        // theme={colourTheme}
        fontSize={8}
      />    
    </div>


    </div>
  );
}

export default Calender